export const assertNever = (_unusedNever: never): never => {
  throw new Error("Didn't expect to get here");
};
